import { ShimmerEffect } from "components/shimmer";

export function TimesheetViewSkeleton() {
  return (
    <div className="p-6 grid grid-cols-10 h-full gap-6 flex-1">
      <div className="col-span-4 flex flex-col gap-4 border-r border-solid">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="space-y-2">
            <ShimmerEffect className="h-4 w-24" /> {/* Label */}
            <ShimmerEffect className="h-4 w-40" /> {/* Value */}
          </div>
        ))}
      </div>
      <div className="col-span-6">
        <div>
          <ShimmerEffect className="h-4 w-24 " /> {/* Label */}
          <div className="mt-2 space-y-2">
            <ShimmerEffect className="h-4 w-96 " />
            <ShimmerEffect className="h-4 max-w-xl " />
            <ShimmerEffect className="h-4 w-80 " />
            <ShimmerEffect className="h-4 w-96 " />
            <ShimmerEffect className="h-4 max-w-xl " />
            <ShimmerEffect className="h-4 w-80 " />
          </div>
        </div>
      </div>
    </div>
  );
}
